import { enum_, EnumDecl, EnumValue } from '../enum';

export type BackgroundSource = EnumValue<'BackgroundSource'>;
export const BackgroundSource: EnumDecl<'BackgroundSource'> = enum_('BackgroundSource', {
  UNDEFINED: [-1, 'undefined'],
  UPLOAD: [1, 'upload'],
  INSTAGRAM: [2, 'instagram'],
  VIDEO: [3, 'video'],
  NONE: [4, 'none'],
});

export type BlockType = EnumValue<'Blocktype'>;
export const BlockType: EnumDecl<'BlockType'> = enum_('BlockType', {
  UNDEFINED: [-1, 'undefined'],
  NAVIGATION: [1, 'navigation'],
  HTML: [2, 'html'],
  LOGO: [3, 'logo'],
  MAP: [4, 'map'],
  IMAGE: [5, 'image'],
  TWITTER: [6, 'twitter'],
  JOURNAL: [7, 'journal'], // does not exist in production
  GALLERY: [8, 'gallery'],
  FORM: [9, 'form'],
  GEO: [10, 'geo'],
  INDEX: [11, 'index'], // does not exist in production
  COLLECTION_LINK: [12, 'collectionlink'],
  LINK: [13, 'link'],
  TAGCLOUD: [14, 'tagcloud'],
  COMMENTS: [16, 'comments'],
  FOLDER: [17, 'folder'],
  MENU: [18, 'menu'],
  SOCIAL_LINKS: [19, 'sociallinks'],
  SUMMARY: [20, 'summary'],
  SPACER: [21, 'spacer'],
  EMBED: [22, 'embed'],
  CODE: [23, 'code'],
  FOURSQUARE: [24, 'foursquare'],
  INSTAGRAM: [25, 'instagram'],
  CALENDAR: [26, 'calendar'],
  POSTS_BY_AUTHOR: [27, 'postsbyauthor'],
  POSTS_BY_TAG: [28, 'postsbytag'],
  POSTS_BY_CATEGORY: [29, 'postsbycategory'],
  POSTS_BY_MONTH: [30, 'postsbymonth'],
  QUOTE: [31, 'quote'],
  VIDEO: [32, 'video'],
  SEARCH: [33, 'search'],
  AUDIO: [41, 'audio'],
  FIVEHUNDREDPIX: [42, 'fivehundredpix'],
  PRODUCT: [43, 'product'],
  MARKDOWN: [44, 'markdown'],
  FLICKR: [45, 'flickr'],
  AMAZON: [46, 'amazon'],
  HORIZONTAL_RULE: [47, 'horizontalrule'],
  SOCIAL_ACCOUNT_LINKS: [48, 'socialaccountlinks'],
  RSS: [49, 'rss'],
  OPENTABLE: [50, 'opentable'],
  NEWSLETTER: [51, 'newsletter'],
  DONATION: [52, 'donation'],
  BUTTON: [53, 'button'],
  SOCIAL_ACCOUNT_LINKS_V2: [54, 'socialaccountlinks-v2'],
  SUMMARY_V2: [55, 'summary-v2'],
  SOUNDCLOUD: [56, 'soundcloud'],
  EMAIL_FOOTER: [57, 'emailfooter'],
  IN_BROWSER_MESSAGE_LINK: [58, 'in-browser-message-link'],
  TOURDATES: [59, 'tourdates'],
  ALBUM: [60, 'album'],
  ARCHIVE: [61, 'archive'],
  CHART: [62, 'chart'],
  ZOLA: [63, 'zola'],
  ACUITY: [65, 'acuity'],
  OPENTABLE_V2: [66, 'opentable-v2'],
  MEMBER_AREA: [67, 'member-area'],
  TOCK: [68, 'tock'],
  ACCORDION: [69, 'accordion'],
});

export type CollectionType = EnumValue<'CollectionType'>;
export const CollectionType: EnumDecl<'CollectionType'> = enum_('CollectionType', {
  UNDEFINED: [-1, 'undefined'],
  COLLECTION_TYPE_GENERIC: [1, 'generic'],
  COLLECTION_TYPE_SUBSCRIPTION: [2, 'subscription'],
  TWITTER: [3, 'twitter'],
  FOURSQUARE: [4, 'foursquare'],
  INSTAGRAM: [5, 'instagram'],
  GALLERY_BLOCK: [6, 'gallery-block'],
  TEMPLATE_PAGE: [7, 'template-page'],
  SPLASH_PAGE: [8, 'splash-page'],
  COLLECTION_TYPE_PAGE: [10, 'page'],
  FIVEHUNDREDPIX: [11, 'fivehundredpix'],
  FLICKR: [12, 'flickr'],
  PRODUCTS: [13, 'products'],
  SLIDE_GALLERY: [15, 'slide-gallery'],
  SLIDE_ALBUM: [16, 'slide-album'],
  SLIDE_VIDEO: [17, 'slide-video'],
  ALBUM_BLOCK: [18, 'album-block'],
});

export type FolderBehavior = EnumValue<'FolderBehavior'>;
export const FolderBehavior: EnumDecl<'FolderBehavior'> = enum_('FolderBehavior', {
  UNDEFINED: [-1, 'undefined'],
  INDEX: [1, 'index'],
  REDIRECT: [2, 'redirect'],
  NONE: [3, 'none'],
});

export type ProductType = EnumValue<'ProductType'>;
export const ProductType: EnumDecl<'ProductType'> = enum_('ProductType', {
  UNDEFINED: [-1, 'undefined'],
  PHYSICAL: [1, 'physical'],
  DIGITAL: [2, 'digital'],
  SERVICE: [3, 'service'],
  GIFT_CARD: [4, 'gift-card'],
});

export type RecordType = EnumValue<'RecordType'>;
export const RecordType: EnumDecl<'RecordType'> = enum_('RecordType', {
  UNDEFINED: [-1, 'undefined'],
  TEXT: [1, 'text'],
  IMAGE: [2, 'image'],
  QUOTE: [4, 'quote'],
  LINK: [5, 'link'],
  AUDIO: [7, 'audio'],
  VIDEO: [8, 'video'],
  STORE_ITEM: [11, 'store-item'],
  EVENT: [12, 'event'],
  GALLERY: [14, 'gallery'],
  BINARY: [15, 'binary'],
  CSSASSET: [16, 'css-asset'],
  TWEAKASSET: [17, 'tweak-asset'],
  DIGITALGOOD: [18, 'digital-good'],
  ATTACHMENT: [19, 'attachment'],
  EXPORT_WORDPRESS: [20, 'wordpress-export'],
  EXPORT_INTERNAL: [21, 'json-export'],
  SITE_SEARCH: [30, 'site-search'],
  ACTIVE_TIME: [31, 'active-time'],
  TWEET: [50, 'tweet'],
  CHECKIN: [52, 'checkin'],
  KBARTICLE: [54, 'kbarticle'],
});

export type SliceType = EnumValue<'SliceType'>;
export const SliceType: EnumDecl<'SliceType'> = enum_('SliceType', {
  UNDEFINED: [-1, 'undefined'],
  HEADING: [1, 'heading'],
  BODY: [3, 'body'],
  IMAGE: [4, 'image'],
  GALLERY: [5, 'gallery'],
  VIDEO: [6, 'video'],
  SOCIAL_ICONS: [7, 'social-icons'],
  BUTTONS: [8, 'buttons'],
  NAVIGATION: [9, 'navigation'],
  CUSTOM_FORM: [10, 'custom-form'],
  NEWSLETTERL: [11, 'newsletter'],
  ALBUM: [12, 'album'],
  MAP: [13, 'map'],
  LOGO: [14, 'logo'],
  ACTION: [15, 'action'],
  FORM: [16, 'form'],
  LOCK: [17, 'lock'],
  PASSWORD: [18, 'password'],
  TWITTER: [19, 'twitter'],
});
